import {notification} from 'antd';
import NProgress from 'nprogress';
import {useEffect} from 'react';
import {createNetworkStatusNotifier} from 'react-apollo-network-status';
import {useDebouncedCallback} from 'use-debounce';

const {link, useApolloNetworkStatus} = createNetworkStatusNotifier();

NProgress.configure({showSpinner: false});

export const networkStatusLink = link;

export const GlobalLoadingIndicator = () => {
  const status = useApolloNetworkStatus();
  const loading = status.numPendingQueries > 0;
  const error = status.queryError || status.mutationError;
  const setLoading = useDebouncedCallback(
    (value) => (value ? NProgress.start() : NProgress.done()),
    250,
    {leading: true}
  );

  const showApplicationError = useDebouncedCallback(
    (description: string) => notification.error({message: 'Application error', description}),
    250,
    {leading: true}
  );
  const showNetworkError = useDebouncedCallback(
    (description: string) => notification.error({message: 'Network error', description}),
    250,
    {leading: true}
  );

  useEffect(() => {
    if (!error) return;
    if (error.graphQLErrors) {
      const graphQLError = error.graphQLErrors[0];
      const resource = graphQLError.path ? graphQLError.path.join('/') : 'Resource';
      showApplicationError(graphQLError.message.replace('Resource', resource));
    } else if (error.networkError) {
      showNetworkError(error.networkError.message);
    }
  }, [error]);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  return null;
};
